import React from 'react'

import { NavDropdown, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

import Submenu from '../Submenu'

import scss from './Item.module.scss';


function _MenuCloseTrigger({ children, onClick }: { children: React.ReactNode, onClick: React.MouseEventHandler<HTMLButtonElement> }, ref: React.Ref<HTMLButtonElement>) {
  return <button
    ref={ref}
    onClick={onClick}
    className={scss.mobileSubmenuHeaderButton}
  >
    <div className={scss.mobileSubmenuTitle}>{children}</div>
    <Icon icon={faChevronDown} className={scss.mobileSubmenuIcon} />
    <div className={scss.mobileSubmenuClose}>
      <div className={scss.mobileSubmenuCloseIcon}>
        &#10005;
      </div>
    </div>
  </button>
}

const MenuCloseTrigger = React.forwardRef(_MenuCloseTrigger)

function Item({ title, submenu }: { title: string, submenu: string }) {
  const MenuComponent = Submenu[submenu];

  return (<NavDropdown className={scss.dropdownContainer} title={<span>{title}</span>}>
    <div className={scss.linkMenuDropdownContainer}>
      <div className={scss.mobileSubmenuHeader}>
        <Dropdown.Toggle as={MenuCloseTrigger}>
          <div className={scss.mobileSubmenuHeaderButton}>
            <div className={scss.mobileSubmenuTitle}>{title}</div>
            <Icon icon={faChevronDown} className={scss.mobileSubmenuIcon} />
            <div className={scss.mobileSubmenuClose}>
              <div className={scss.mobileSubmenuCloseIcon}>
                &#10005;
              </div>
            </div>
          </div>
        </Dropdown.Toggle>
      </div>
      <MenuComponent />
    </div>
  </NavDropdown>)
}

export default Item